module.exports = __webpack_public_path__ + "static/media/kefu.137f7957.png";